export default "__VITE_ASSET__BAzp6ID0__"